var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    { attrs: { nav: false, "has-fixed-group": true } },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("h1", [_vm._v("Select Recipients")]),
          _vm._v(" "),
          _c("ValidationAlert", {
            attrs: { "error-list": _vm.errors.collect("server") },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("GridMembers", {
            attrs: { selectable: true, hideMergers: true },
            model: {
              value: _vm.formData.members,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "members", $$v)
              },
              expression: "formData.members",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit-fixed" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: ["submit"],
                    expression: '["submit"]',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Send Opportunity")]
            ),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }